import { Injectable, SecurityContext, Inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable, of } from 'rxjs';

import { LocalStorageService } from '../local-storage/local-storage.service';
import {
    STORAGE_HKEY,
    STORAGE_AUTH_TOKEN,
    STORAGE_CHAT_HISTORY_SUFFIX,
    STORAGE_CHAT_MESSAGES_SUFFIX,
    BOM_DEV_ENV_URL,
    BOM_PROD_ENV_URL
} from '../../constants/craig.constants';

@Injectable({
    providedIn: 'root'
})
export class UtilsService {
    constructor(
        private readonly sanitizer: DomSanitizer,
        private readonly _window: Window,
        private readonly localStorageService: LocalStorageService
    ) {}

    redirectToUrl(url: string): Observable<undefined> {
        const sanitizedUrl: string | null = this.sanitizeUrl(url);

        if (sanitizedUrl && !sanitizedUrl.startsWith('unsafe')) {
            this._window.location.href = sanitizedUrl;
        }

        return of(undefined);
    }

    cleanAuthDataStorage(): void {
        this.localStorageService.removeItem(STORAGE_AUTH_TOKEN);
        this.localStorageService.removeItem(STORAGE_HKEY);
    }

    cleanChatSessionStorage(): void {
        const localStorageKeys: string[] = this.localStorageService.getAllKeys();

        localStorageKeys.forEach((key: string) => {
            if (key.endsWith(STORAGE_CHAT_HISTORY_SUFFIX) || key.endsWith(STORAGE_CHAT_MESSAGES_SUFFIX)) {
                this.localStorageService.removeItem(key);
            }
        });
    }

    resolveDatasheetUrl(path: string): string {
        if (!path) {
            return '';
        }

        const normalizedPath: string = path.startsWith('/') ? path : `/${path}`;
        const baseDomain: string = this.getDatasheetBaseDomain();
        const resolvedUrl: string = `${baseDomain}${normalizedPath}`;
        const hkey: string | null = this.localStorageService.getRawItem(STORAGE_HKEY);

        if (!hkey) {
            return resolvedUrl;
        }

        return `${resolvedUrl}?hkey=${encodeURIComponent(hkey)}`;
    }

    /**
     * Datasheet links should use different domains in dev and prod.
     */
    private getDatasheetBaseDomain(): string {
        const hostname: string = this._window.location.hostname;

        const isDevEnvironment: boolean =
            hostname.includes('localhost') ||
            hostname.includes('dev');

        if (isDevEnvironment) {
            return BOM_DEV_ENV_URL;
        }

        return BOM_PROD_ENV_URL;
    }

    private sanitizeUrl(url: string): string | null {
        return this.sanitizer.sanitize(SecurityContext.URL, url);
    }
}
